const config = {
  filterTitles: {
    division: 'Division',
    property_id: 'Building',
    region: 'Region',
  },
};

export default config;
